import actionTypes from './actionTypes';

const INITIAL_STATE = {
  introduceCafeLoading: false,
  introduceCafeFailed: false,
  introduceCafeReject: false,
  introduceCafeMessage: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.INTRODUCE_CAFE_LOADING: {
      return {
        ...state,
        introduceCafeLoading: true,
        introduceCafeFailed: false,
        introduceCafeReject: false,
        introduceCafeMessage: [],
      };
    }
    case actionTypes.INTRODUCE_CAFE_SUCCESS: {
      return {
        ...state,
        introduceCafeLoading: false,
        introduceCafeFailed: false,
        introduceCafeReject: false,
        introduceCafeMessage: [],
      };
    }
    case actionTypes.INTRODUCE_CAFE_FAILED: {
        const { message } = action.payload;
      return {
        ...state,
        introduceCafeLoading: false,
        introduceCafeFailed: true,
        introduceCafeReject: false,
        introduceCafeMessage: message,
      };
    }
    case actionTypes.INTRODUCE_CAFE_REJECT: {
      return {
        ...state,
        introduceCafeLoading: false,
        introduceCafeFailed: false,
        introduceCafeReject: true,
        introduceCafeMessage: [],
      };
    }

    default:
      return state;
  }
};
